import axiosInstance from "global/helpers/axiosInstance";
import {
  REGISTRO_SUCCESS,
  REGISTRO_LOADING,
  REGISTRO_ERROR,
  REGISTRO_SETUSUARIO,
  REGISTRO_SETERRORUSUARIO,
} from "../../ActionTypes";

export const setUsuario = (usuario) => (dispatch) => {
  dispatch({
    type: REGISTRO_SETUSUARIO,
    payload: usuario,
  });
};

export const setListError = (listError) => (dispatch) => {
  dispatch({
    type: REGISTRO_SETERRORUSUARIO,
    payload: listError,
  });
};

export const resetErrorReg = () => (dispatch) => {
  dispatch({
    type: REGISTRO_ERROR,
    payload: null,
  });
};
